module.exports = __webpack_public_path__ + "static/couture06-a4ff853cfae74c1296ad5bb6c59d1564.png";